import Breadcrumb from "components/shared/breadcrumb/Breadcrumb";
import Footer from "components/shared/footer/Footer";
import Header from "components/shared/header/Header";
import Loader from "components/shared/loader/Loader";
import { API_BASE_URL } from "config/config";
import React, { useState } from "react";

const INITIAL_FORM_DATA = {
  name: "",
  email: "",
  order_number: "",
  withdrawal_details: "",
};

const INITIAL_VALIDATION = {
  name_error: "",
  email_error: "",
  order_number_error: "",
  withdrawal_details_error: "",
  submit_error: "",
};

const MAX_NAME_LENGTH = 150;
const MAX_EMAIL_LENGTH = 254;
const MAX_ORDER_NUMBER_LENGTH = 100;
const MAX_DETAILS_LENGTH = 5000;
const ORDER_NUMBER_REGEX = /^HFC-\d{6}\/\d{1,2}$/;

function WithdrawalDeclaration() {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [validation, setValidation] = useState(INITIAL_VALIDATION);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [declarationMessage, setDeclarationMessage] = useState("");

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailPattern.test(email);
  };

  const validateOrderNumber = (orderNumber) => {
    const orderNumberPattern = /^[a-zA-Z0-9À-ž._/-]+$/;

    return orderNumberPattern.test(orderNumber);
  };

  const validateForm = () => {
    const errors = {
      ...INITIAL_VALIDATION,
    };

    const name = formData.name.trim();
    const email = formData.email.trim();
    const orderNumber = formData.order_number.trim();
    const withdrawalDetails = formData.withdrawal_details.trim();

    if (name === "") {
      errors.name_error = "A név megadása kötelező.";
    } else if (name.length < 2) {
      errors.name_error = "A névnek legalább 2 karakter hosszúnak kell lennie.";
    } else if (name.length > MAX_NAME_LENGTH) {
      errors.name_error = `A név legfeljebb ${MAX_NAME_LENGTH} karakter hosszú lehet.`;
    }

    if (email === "") {
      errors.email_error = "Az e-mail-cím megadása kötelező.";
    } else if (email.length > MAX_EMAIL_LENGTH) {
      errors.email_error = `Az e-mail-cím legfeljebb ${MAX_EMAIL_LENGTH} karakter hosszú lehet.`;
    } else if (!validateEmail(email)) {
      errors.email_error = "Kérjük, adjon meg egy érvényes e-mail-címet.";
    }

    if (orderNumber === "") {
      errors.order_number_error = "A rendelésszám megadása kötelező.";
    } else if (orderNumber.length > MAX_ORDER_NUMBER_LENGTH) {
      errors.order_number_error =
    `A rendelésszám legfeljebb ${MAX_ORDER_NUMBER_LENGTH} karakter hosszú lehet.`;
    } else if (!ORDER_NUMBER_REGEX.test(orderNumber)) {
      errors.order_number_error =
    "A rendelésszám formátuma hibás.";
    }

    if (withdrawalDetails.length > MAX_DETAILS_LENGTH) {
      errors.withdrawal_details_error =
        `Az elállás részletei legfeljebb ${MAX_DETAILS_LENGTH} karakter hosszúak lehetnek.`;
    }

    setValidation(errors);

    return !Object.keys(errors).some((key) => errors[key] !== "");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previousFormData) => ({
      ...previousFormData,
      [name]: value,
    }));

    const validationFieldName = `${name}_error`;

    setValidation((previousValidation) => ({
      ...previousValidation,
      [validationFieldName]: "",
      submit_error: "",
    }));

    setIsSubmitted(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSuccess(null);

    if (isLoaderActive) {
      return;
    }

    if (!validateForm()) {
      return;
    }

    setIsLoaderActive(true);
    setIsSubmitted(false);

    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      order_number: formData.order_number.trim(),
      withdrawal_details: formData.withdrawal_details.trim(),
    };

    try {
      fetch(`${API_BASE_URL}/withdraw-declaration`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then(
          (json) => {
            if (json.success) {
              setIsSuccess(true);
              setFormData(INITIAL_FORM_DATA);
              setValidation(INITIAL_VALIDATION);
              setDeclarationMessage(json.message);
            } else {
              setIsSuccess(false);
            }
            setIsLoaderActive(false);
          },
          (error) => {
            setIsLoaderActive(false);
            setIsSuccess(false);
            console.log(error);}
        );

      setIsSubmitted(true);
    } catch (error) {
      setValidation((previousValidation) => ({
        ...previousValidation,
        submit_error:
          error && error.message
            ? error.message
            : "Az elállási nyilatkozat beküldése sikertelen. Kérjük, próbálja újra.",
      }));
    }
  };

  return (
    <div className="fixtures-container">
      <Header />
      <Breadcrumb />

      <section className="main-content">
        <div className="container login-container profile-container">
          <h2 className="h2">Online elállási nyilatkozat</h2>
          <p>Az alábbi űrlapon egyszerűen bejelentheti, hogy el kíván állni a rendelésétől. Kérjük, adja meg a szükséges adatokat, részleges elállás esetén pedig az „Elállás részletei” mezőben tüntesse fel az érintett termékeket és mennyiségeket. A nyilatkozat elküldését követően visszaigazolást küldünk a megadott e-mail-címre.
          </p>
          {isSuccess && (
            <div className="login-success-message">{declarationMessage}</div>
          )}
          {isSuccess === false && (
            <div className="login-error-message">
              Hiba az elállási nyilatkozat elküldésekor! Kérjük, próbáld meg később.
            </div>
          )}
          <form onSubmit={handleSubmit} noValidate>
            <fieldset
              disabled={isLoaderActive}
              style={{
                border: 0,
                margin: 0,
                padding: 0,
                minWidth: 0,
              }}
            >
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="withdrawal_name">
              Név
                    <span>*</span>
                  </label>

                  <input
                    title=""
                    type="text"
                    className="form-control"
                    id="withdrawal_name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    maxLength={MAX_NAME_LENGTH}
                    autoComplete="name"
                    aria-invalid={validation.name_error !== ""}
                    aria-describedby="withdrawal_name_error"
                  />

                  <div
                    id="withdrawal_name_error"
                    className="validation_error"
                    role={validation.name_error ? "alert" : undefined}
                  >
                    {validation.name_error}
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="withdrawal_email">
              E-mail-cím
                    <span>*</span>
                  </label>

                  <input
                    title=""
                    type="email"
                    className="form-control"
                    id="withdrawal_email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    maxLength={MAX_EMAIL_LENGTH}
                    autoComplete="email"
                    aria-invalid={validation.email_error !== ""}
                    aria-describedby="withdrawal_email_error"
                  />

                  <div
                    id="withdrawal_email_error"
                    className="validation_error"
                    role={validation.email_error ? "alert" : undefined}
                  >
                    {validation.email_error}
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="withdrawal_order_number">
              Rendelés száma
                    <span>*</span>
                  </label>

                  <input
                    title=""
                    type="text"
                    className="form-control"
                    id="withdrawal_order_number"
                    name="order_number"
                    value={formData.order_number}
                    onChange={handleChange}
                    maxLength={MAX_ORDER_NUMBER_LENGTH}
                    autoComplete="off"
                    aria-invalid={validation.order_number_error !== ""}
                    aria-describedby="withdrawal_order_number_error"
                  />

                  <div
                    id="withdrawal_order_number_error"
                    className="validation_error"
                    role={validation.order_number_error ? "alert" : undefined}
                  >
                    {validation.order_number_error}
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="withdrawal_details">
              Elállás részletei
                    <small> (opcionális)</small>
                  </label>

                  <textarea
                    title=""
                    className="form-control"
                    id="withdrawal_details"
                    name="withdrawal_details"
                    value={formData.withdrawal_details}
                    onChange={handleChange}
                    rows="6"
                    maxLength={MAX_DETAILS_LENGTH}
                    aria-invalid={validation.withdrawal_details_error !== ""}
                    aria-describedby="withdrawal_details_help withdrawal_details_error"
                  />

                  <small
                    id="withdrawal_details_help"
                    className="form-text text-muted"
                  >
              Részleges elállás esetén kérjük, itt sorolja fel az elállással
              érintett termékeket és azok mennyiségét.
                  </small>

                  <div
                    id="withdrawal_details_error"
                    className="validation_error"
                    role={
                      validation.withdrawal_details_error ? "alert" : undefined
                    }
                  >
                    {validation.withdrawal_details_error}
                  </div>
                </div>
              </div>

              {validation.submit_error !== "" && (
                <div className="validation_error text-center" role="alert">
                  {validation.submit_error}
                </div>
              )}

              <div className="text-center submit-container">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoaderActive === true}
                >
            Elállás megerősítése
                </button>

                {isLoaderActive === true && <Loader />}
              </div>
            </fieldset>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default WithdrawalDeclaration;
